module.exports = __webpack_public_path__ + "static/media/interview_declined.82c7ea3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/interview_declined.svg
// module id = 1347
// module chunks = 1